import React, { Fragment, useState, useRef } from "react";
import { ActionCable } from 'react-actioncable-provider';

import Toastr from "./toastr";

const InspectionChannel = (props) => {
  const { onRefresh } = props;

  const defaultState = {
    messageShown: false,
    messageHeader: '',
    messageBody: '',
    messageType: '',
    messageClass: ''
  }
  const [state, setState] = useState(defaultState);
  const { messageShown, messageHeader, messageBody, messageType, messageClass } = state;

  const channelRef = useRef('inspectionChannel');

  const dismissMessage = () => {
    setState({
      messageShown: false,
      messageHeader: '',
      messageBody: '',
      messageType: '',
      messageClass: ''
    })
  }

  const onReceived = (received_data) => {
    onRefresh(received_data)
  }

  return (
    <Fragment>
      <ActionCable ref={channelRef} channel={ { channel: 'InspectionChannel'} } onReceived={onReceived} />
      {
        messageShown &&
        <Toastr className={messageClass} messageHeader={messageHeader} messageBody={messageBody} messageType={messageType} dismiss={ dismissMessage }/> 
      }
    </Fragment>
  )
}

export default InspectionChannel;


// WEBPACK FOOTER //
// ./src/components/inspection_channel.js